import { HighContrastSelector, IRawStyle } from '@fluentui/react';

import { commonHighContrastDisabledStyles, controlStylingConstants } from '@1js/acui-common';

import { RibbonMode } from './components';

export interface RibbonModeStylingConstants {
  bottomBarHeight: number;
  groupDividerPadding: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
}

export const modernUxRibbonStylingConstants = {
  tabHeaderHeight: 32,
  tabHeaderMarginTop: 2,
  tabHeaderMarginLeft: 4,
  tabHeaderBorderRadius: 4,
  borderRadius: 20,
  dividerPaddingTop: 10,
  dividerPaddingBottom: 10,
};

export const ribbonStylingConstants = {
  bottomBarZIndex: 2,
  topBarHeight: 36,
  tabHeaderHeight: 31,
};

export const fastDisabled: IRawStyle = {
  selectors: {
    ['&']: {
      opacity: 0.4,
      pointerEvents: 'none',
    },
    // Make sure all appropriate content is styled as disabled in HC
    ['&, & button, & input[type="text"], & div, & span, & label']: [
      commonHighContrastDisabledStyles,
      {
        selectors: {
          [HighContrastSelector]: {
            selectors: {
              ['[aria-pressed="true"], [aria-checked="true"]']: {
                backgroundColor: 'highlight',
              },
            },
          },
        },
      },
    ],
  },
};

export const ribbonModeStylingConstantsSLR: RibbonModeStylingConstants = {
  bottomBarHeight: controlStylingConstants.controlHeight,
  groupDividerPadding: { top: 4, right: 4, bottom: 4, left: 4 },
};

export const ribbonModeStylingConstantsMLR: RibbonModeStylingConstants = {
  bottomBarHeight: 90,
  groupDividerPadding: { top: 0, right: 8, bottom: 2, left: 8 },
};

export function getModeStylingConstants(mode: RibbonMode): RibbonModeStylingConstants {
  return mode === 'SingleLine' ? ribbonModeStylingConstantsSLR : ribbonModeStylingConstantsMLR;
}
